import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => ({
  pageHeader: {
    display: "flex",
    padding: "0 24px",
    justifyContent: "space-between",
    height: "initial",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column-reverse",
      padding: 0
    }
  },
  mainHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    zIndex: 2,
    padding: "7px 0 0 24px",
    [theme.breakpoints.down("xs")]: {
      height: 54,
      padding: "10px 16px 4px"
    }
  },
  tabBar: {
    maxWidth: 600,
    "& .mdc-tab": {
      fontFamily: "SuisseIntlRegular",
      color: "rgba(186, 186, 186, 1)",
      textTransform: "capitalize",
      padding: "0 16px",
      fontSize: 16,
      letterSpacing: "unset",
      height: 60,
      flex: "unset",
      minWidth: 90,
      maxWidth: 150,
      [theme.breakpoints.down("sm")]: {
        padding: "0 8px",
        minWidth: 60
      },
      [theme.breakpoints.down("xs")]: {
        height: 36,
        maxWidth: 120,
        padding: "0 16px"
      }
    },
    "& .mdc-tab-scroller": {
      height: 60,
      [theme.breakpoints.down("xs")]: {
        height: 36
      }
    },
    "& .mdc-tab-scroller__scroll-area--scroll": {
      scrollbarWidth: "none"
    },
    "& .mdc-tab__content": {
      [theme.breakpoints.up("sm")]: {
        alignItems: "flex-start",
        paddingTop: 26
      }
    },
    "& .mdc-tab--active .mdc-tab__text-label": {
      color: theme.palette.text.primary
    },
    "& .mdc-tab-indicator > .mdc-tab-indicator__content--underline ": {
      backgroundColor: "#000000",
      height: 2
    },
    "& .mdc-tab__ripple::before, .mdc-tab__ripple::after": {
      backgroundColor: "transparent"
    }
  },
  buttons: {
    display: "flex",
    alignItems: "center",
    paddingBottom: 8,
    [theme.breakpoints.down("xs")]: {
      paddingBottom: 0
    }
  },
  createWorkOrderButton: {
    paddingBottom: 8,
    marginLeft: 20
  },
  snackbar: {
    bottom: 60,
    display: "flex",
    justifyContent: "center",
    "& .MuiAlert-root": {
      padding: "6px 12px"
    },
    [theme.breakpoints.up(Breakpoints.SX_720)]: {
      width: `calc(100% - ${theme.widthTabletDrawer}px)`,
      left: "55%"
    },
    [theme.breakpoints.up(Breakpoints.LG_1280)]: {
      width: `calc(100% - ${theme.widthDesktopDrawer}px)`
    }
  },
  successSnack: {
    backgroundColor: "rgba(72, 155, 119, 1)"
  },
  successSnackMessage: {
    fontSize: 16
  },
  appPageContent: {
    zIndex: 1,
    overflowX: "hidden",
    [theme.breakpoints.up("sm")]: {
      padding: 22
    },
    [theme.breakpoints.down("xs")]: {
      "& .MuiGrid-spacing-xs-2": {
        width: "100%",
        margin: 0,
        "& .MuiGrid-item": {
          padding: 0
        }
      }
    }
  },
  columnPaper: {
    flex: "auto",
    minHeight: "100%",
    height: "100%",
    display: "flex",
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      overflow: "auto"
    }
  },
  detailsWrapper: {
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      display: "none"
    }
  },
  hideDownXs: {
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      display: "none"
    }
  },
  expandMoreIcon: {
    fontSize: 32
  },
  workOrdersInfo: {
    fontFamily: "SuisseIntlRegular",
    fontSize: 16,
    color: "rgba(127, 127, 127, 1)",
    lineHeight: "41px",
    whiteSpace: "nowrap",
    "&.hasWorkOrders": {
      color: theme.palette.text.primary
    }
  },
  mobileAnchor: {
    width: "100%",
    height: "100vh",
    left: 0,
    top: 0,
    position: "fixed",
    pointerEvents: "none"
  },
  infiniteLoader: {
    position: "absolute",
    width: 80,
    height: 80,
    margin: "0 auto",
    left: "calc(50% - 40px)",
    display: "none"
  },
  showInfiniteLoader: {
    bottom: 20,
    display: "block"
  },
  showOverlayLoader: {
    display: "flex",
    alignItems: "flex-end",
    maxWidth: "100%",
    width: "100%",
    height: "100%",
    left: 0,
    margin: 0,
    top: 0,
    right: 0,
    paddingBottom: "40%",
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.9)"
  }
}));
